import { Component } from "@angular/core";

@Component({
  selector: 'lpcr-topbar',
  standalone: true,
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopBarComponent {
}
